<div class="heading py-5">
  <h1 class="bold font-curve-large">Feedback</h1>
</div>

<section>
  <app-feedback-demo></app-feedback-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
